import { render, staticRenderFns } from "./WechatPatientReport.vue?vue&type=template&id=ea650dca&scoped=true"
import script from "./WechatPatientReport.vue?vue&type=script&lang=js"
export * from "./WechatPatientReport.vue?vue&type=script&lang=js"
import style0 from "./WechatPatientReport.vue?vue&type=style&index=0&id=ea650dca&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea650dca",
  null
  
)

export default component.exports